<div
  class="list-view-container"
  [class.minimized-vehicle-groups]="minimized() && vehicleGroups()"
  [class.minimized]="minimized() && !vehicleGroups()"
  [class.vehicle-groups]="vehicleGroups() && !minimized()"
>
  @if (!loading()) {
    <div class="events-list">
      @for (event of processedEvents(); track event.meta?.ride?.id || $index) {
        <app-event-item
          [ride]="event.meta?.ride"
          [vehicle]="event.meta?.vehicle"
          (itemClicked)="onEventClick(event)"
        ></app-event-item>
      }

      @if (processedEvents().length === 0) {
        <div class="no-events">
          <p>Geen ritten gevonden voor deze dag</p>
        </div>
      }
    </div>
  }
</div>
